import {useMutation} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {CustomerRestoreMutation, CustomerRestoreProps} from './customer-restore.models';

export function useCustomerRestoreMutation(props: CustomerRestoreProps): CustomerRestoreMutation {
  const {isPending, mutate} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.putNullable(`${environment.apiv4uri}customer/${props.id}/restore`, null),
  });

  return {
    isPending,
    mutate: (cb) => mutate(null, {onSuccess: () => cb()}),
  };
}
